<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <div class="flex items-center justify-between">
        <h4 class="text-indigo-500">
          {{ $t('creatives') | capitalize }}
        </h4>
        <RouterLink
          v-if="$membershipHasPermissionTo('create media')"
          :to="{ name: 'accounts.campaigns.media.create' }"
          class="btn btn-brand px-6"
        >
          {{ $t('addCreatives') | capitalize }}
        </RouterLink>
      </div>
      <div class="flex flex-wrap -mx-4">
        <div
          v-for="mediaItem in media"
          :key="mediaItem.id"
          class="w-1/3 px-4 pb-8 text-center space-y-2"
        >
          <img
            :srcset="mediaItem.srcsets || ''"
            @load.once="onImageLoad"
            sizes="1px"
            :src="mediaItem.url"
            class="block rounded w-full"
          />
          <div class="flex justify-between">
            <RouterLink
              v-if="$membershipHasPermissionTo('delete media')"
              :to="{
                name: 'accounts.campaigns.media.delete',
                params: { mediaItemId: mediaItem.id },
              }"
              class="btn btn-danger"
            >
              <FontAwesomeIcon icon="trash" />
            </RouterLink>
            <div class="glue-h">
              <RouterLink
                v-if="$membershipHasPermissionTo('edit media')"
                :to="{
                  name: 'accounts.campaigns.media.edit',
                  params: { mediaItemId: mediaItem.id },
                }"
                class="btn btn-brand"
              >
                <FontAwesomeIcon icon="edit" />
              </RouterLink>
              <a
                v-if="mediaItem.visitUrl"
                :href="mediaItem.visitUrl"
                class="btn btn-brand"
                target="_blank"
              >
                <FontAwesomeIcon icon="external-link-alt" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <RouterView name="modal" />
    </div>
  </div>
</template>

<script>
import { campaignMediaComputed, campaignMediaMethods } from '@/store/helper';
import { middleware } from '@/routes/guards';
import mediableMixin from '@/mixins/mediableMixin';

export default {
  mixins: [mediableMixin],
  props: {
    campaignId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...campaignMediaComputed,
  },
  beforeRouteEnter: middleware('account-permission:read media'),
  created() {
    this.fetching = true;
    const { campaignId } = this;
    this.getCampaignMedia({ campaignId })
      .then(() => {
        this.fetching = false;
      })
      .catch(() => {
        this.fetching = false;
      });
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...campaignMediaMethods,
  },
};
</script>
